import { HopperApiClient, TransformOptionsType } from "../providers/hopperApiClient";
import { HttpHeaders } from "@angular/common/http";

export class HopperOctopusApiClient extends HopperApiClient {
  protected getBaseUrl(baseUrl: string): string {
    const config = this.config.getConfig();

    return config.apiUrl;
  }

  protected async transformOptions(options: TransformOptionsType): Promise<TransformOptionsType> {
    if ("headers" in options ) {
      const bearerToken = this.config.getAuthToken();

      options.headers = (options.headers as HttpHeaders)
        .set("Authorization", `Bearer ${bearerToken}`)
        .set("accept-language", "pt-BR");
    }

    return Promise.resolve(options);
  }
}
